/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TripRecommendation } from '../models/TripRecommendation';
import type { TripRequest } from '../models/TripRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TripService {
    /**
     * Get Trip Recommendations
     * Get trip recommendations for a given destination.
     *
     * Args:
     * request: TripRequest containing the user's query
     *
     * Returns:
     * TripRecommendation containing attractions and user-friendly response
     *
     * Raises:
     * HTTPException: If there's an error getting recommendations
     * @returns TripRecommendation Successful Response
     * @throws ApiError
     */
    public static getTripRecommendationsApiV1TripRecommendationsPost({
        requestBody,
    }: {
        requestBody: TripRequest,
    }): CancelablePromise<TripRecommendation> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/trip/recommendations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
